@for (option of sortOptions; track option) {
  <buyiq-sort-menu-option (selectOption)="onSelectSortOption($event)"
    [isSelected]="option.isSelected"
    [sortDirection]="option.sortDirection"
    [sortOption]="option"
    mat-ripple>
  </buyiq-sort-menu-option>
}
